const eventBus = window.theme.searchAutocomplete.eventBus

class SearchDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    eventBus.subscribe(
      'searchAutoComplete:state:updated',
      this.render.bind(this),
    )
    eventBus.subscribe(
      'searchAutoComplete:ui:dropdown:open',
      this.handleDropdownOpen.bind(this),
    )
    eventBus.subscribe(
      'searchAutoComplete:ui:dropdown:close',
      this.handleDropdownClose.bind(this),
    )

    this.handleBackdropClick = this.handleBackdropClick.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handleDropdownClose = this.handleDropdownClose.bind(this)

    if (this?.externalEls?.backdrop?.exists) {
      this.listeners.add(
        this.externalEls.backdrop.element,
        'click',
        this.handleBackdropClick,
      )
    }

    this.listeners.add(document, 'click', this.handleCloseClick)

    document.addEventListener('dropdown:open', (e) => {
      this.handleDropdownClose()
    })

    document.addEventListener('keyup', this.handleEscapePress.bind(this))
  }

  render () {
    if (window.theme.searchAutocomplete.stateLayer.state.term === '') {
      this.els.initialView.element.classList.remove('hidden')
      this.els.searchedView.element.classList.add('hidden')
      return
    }

    this.els.searchedViewZero.element.innerHTML = ''
    this.els.searchedViewAside.element.innerHTML = ''
    this.els.searchedViewList.element.innerHTML = ''

    const resultsCount =
      window.theme.searchAutocomplete.stateLayer.state.products.hits.length

    if (resultsCount > 0) {
      this.els.initialView.element.classList.add('hidden')
      this.els.searchedView.element.classList.remove('hidden')

      if (window.theme.searchAutocomplete.stateLayer.state.keywords) {
        this.els.searchedViewAside.element.insertAdjacentHTML(
          'beforeend',
          this.buildSuggestedKeywords(),
        )

        this.attachKeywordClickEvent()
      }

      this.els.searchedViewList.element.insertAdjacentHTML(
        'beforeend',
        this.buildResultsList(),
      )

      this.attachProductClickEvent()
    } else {
      this.els.initialView.element.classList.remove('hidden')
      this.els.searchedView.element.classList.add('hidden')

      this.els.searchedViewZero.element.insertAdjacentHTML(
        'beforeend',
        `${window.theme.searchStrings.noSearchResults} '${window.theme.searchAutocomplete.stateLayer.state.term}'`,
      )
    }
  }

  buildSuggestedKeywords () {
    const keywords =
      window.theme.searchAutocomplete.stateLayer.state.keywords.hits
    const searchTerm = window.theme.searchAutocomplete.stateLayer.state.term

    const html = `
      <div class="hd-SearchDropdown_Terms">
        <h3 class="hd-SearchDropdown_SubHeading fz-20_110">${window.theme.searchStrings.searchSuggestions}</h3>

        <ul class="hd-SearchDropdown_TermList">
          ${keywords
            .map((i) => {
              const highlightedKeyword = i.keyword.replace(
                new RegExp(`(${searchTerm})`, 'gi'),
                '<strong>$1</strong>',
              )
              const cnstrcAttributes = this.buildCnstrcItemAttributes({
                itemId: i.itemId,
                itemName: i.keyword,
                section: 'Search Suggestions',
              })

              return `
              <li class="hd-SearchDropdown_TermItem" ${cnstrcAttributes}>
                <a href="/search/?q=${i.keyword}" data-search-dropdown-el="keyword" class="hd-SearchDropdown_TermLink btn-Button btn-Button-link fz-16_130">
                  ${highlightedKeyword}
                </a>
              </li>
            `
            })
            .join('')}
        </ul>
      </div>
    `
    return html
  }

  buildResultsList () {
    const products =
      window.theme.searchAutocomplete.stateLayer.state.products.hits

    const html = `
      <div class="hd-SearchDropdown_Row">  
        <h3 class="hd-SearchDropdown_SubHeading fz-20_110">${window.theme.searchStrings.suggestedProducts}</h3>

        <div class="hd-SearchDropdown_RowButtons">
          <a href="/search/?q=${window.theme.searchAutocomplete.stateLayer.state.term}" data-search-dropdown-el="viewAll" class="hd-SearchDropdown_CollectionViewAll btn-Button-underlined">${window.theme.searchStrings.shopAll}</a>

          <button
            type="button"
            class="hd-SearchDropdown_CloseButton hd-SearchDropdown_CloseButton-desktopOnly"
            data-search-dropdown-el="closeDropdown"
            aria-label="Close"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1.1543" width="20.9932" height="1.63281" rx="0.816403" transform="rotate(45 1.1543 0)" fill="currentColor"/>
              <rect x="16" y="1.15479" width="20.9932" height="1.63281" rx="0.816403" transform="rotate(135 16 1.15479)" fill="currentColor"/>
            </svg>
          </button>
        </div>
      </div>

      <ul class="hd-SearchDropdown_Grid">
        ${products
          .map((product) => {
            const clone = document.importNode(
              this.templateProductCard.content,
              true,
            )
            const productCard = clone.querySelector('product-card')
            productCard.setAttribute('data-prop-data', JSON.stringify(product))
            const cnstrcAttributes = this.buildCnstrcItemAttributes({
              itemId: product.productId,
              itemName: product.itemName,
              section: 'Products',
            })

            // Create a temporary container to hold the product card HTML
            const tempContainer = document.createElement('div')
            tempContainer.appendChild(clone)

            return `
            <li class="hd-SearchDropdown_Item" ${cnstrcAttributes}>
              ${tempContainer.querySelector('product-card').outerHTML}
            </li>
          `
          })
          .join('')}
      </ul>
    `
    return html
  }

  buildCnstrcItemAttributes ({ section, itemName, itemId = '' }) {
    return [
      this.buildCnstrcAttribute('data-cnstrc-item-section', section),
      this.buildCnstrcAttribute('data-cnstrc-item-name', itemName),
      this.buildCnstrcAttribute('data-cnstrc-item-id', itemId),
    ]
      .filter(Boolean)
      .join(' ')
  }

  buildCnstrcAttribute (name, value) {
    if (!value) {
      return ''
    }

    return `${name}="${this.escapeCnstrcAttribute(value)}"`
  }

  escapeCnstrcAttribute (value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
  }

  attachProductClickEvent () {
    // Ensure we only bind once
    if (this._productClickBound) return
    this._productClickBound = true

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-product-card-el="link"]')
      if (!link) return

      const productCard = link.closest('product-card')
      if (!productCard) return

      try {
        const productData = JSON.parse(productCard.dataset.propData)

        if (window.Shopify.trackingConsent.analyticsProcessingAllowed()) {
          eventBus.publish('searchAutoComplete:tracking:product:clicked', {
            itemName: productData.itemName,
            productId: productData.productId,
            url: productData.url,
          })
        }
      } catch (err) {
        console.error('Invalid product data', err)
      }
    })
  }

  attachKeywordClickEvent () {
    this.querySelectorAll('[data-search-dropdown-el="keyword"]').forEach(
      (link) => {
        link.addEventListener('click', this.handleKeywordClick.bind(this))
      },
    )
  }

  handleKeywordClick (event) {
    const term = event.currentTarget.textContent.replace(/\n/g, '').trim()

    const keywordData = {
      keyword: term,
      originalQuery: window.theme.searchAutocomplete.stateLayer.state.term,
    }

    if (Shopify.trackingConsent.analyticsProcessingAllowed()) {
      sessionStorage.setItem(
        'autocompleteKeyword',
        JSON.stringify(keywordData),
      )
    }
  }

  handleDropdownOpen () {
    this.dialog.show()

    document.body.classList.add('util-SearchOpen')
  }

  handleCloseClick (event) {
    const clickedInside = event?.target?.closest(
      '[data-search-dropdown-external-el="dialog"]',
    )
    const clickedSearchInput = event?.target?.closest('search-input')
    const clickedMobileTrigger = event?.target?.closest(
      '[data-search-input-external-el="trigger"]',
    )

    const clickedCloseButton = event?.target?.closest(
      '[data-search-dropdown-el="closeDropdown"]',
    )

    if (
      (clickedInside || clickedSearchInput || clickedMobileTrigger) &&
      !clickedCloseButton
    ) {
      return
    }

    this.handleDropdownClose()
  }

  handleBackdropClick () {
    this.handleDropdownClose()
  }

  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return

    this.handleDropdownClose()
  }

  handleDropdownClose () {
    this.dialog.close()
    this.dialog.removeAttribute('open')

    document.body.classList.remove('util-SearchOpen')
  }

  get dialog () {
    return this.closest('dialog')
  }

  get templateProductCard () {
    return document.getElementById('templateProductCard')
  }
}

if (!customElements.get('search-dropdown')) {
  customElements.define('search-dropdown', SearchDropdown)
}
